module.exports = new __parcel__URL__("wave-rt.60fadf00.png").toString();